// src/containers/Codes/stylesCodes.js

import CodeSet from './CodeSet';

const stylesCodes = new CodeSet('styles', { fr: 'modes', it: 'stili', es: 'estilos' });

// Classic
stylesCodes.addData(0, {
  name: { en: 'classic', fr: 'classique', it: 'classico', es: 'clásico' },
  summary: {
    en: 'Timeless elegance defines our classic rugs. Hand-woven or machine-made with exquisite craftsmanship, these rugs boast traditional patterns and rich colors that seamlessly blend with any décor style. From Persian rugs with intricate floral motifs to Turkish kilims with geometric designs, our classic collection offers a touch of heritage for your home.',
    fr: "L'élégance intemporelle définit nos tapis classiques. Tissés à la main ou fabriqués à la machine avec un savoir-faire exquis, ces tapis arborent des motifs traditionnels et des couleurs riches qui s'intègrent parfaitement à tout style de décoration. Des tapis persans aux motifs floraux complexes aux kilims turcs aux dessins géométriques, notre collection classique offre une touche de patrimoine à votre intérieur.",
    it: "L'eleganza senza tempo definisce i nostri tappeti classici. Tessuti a mano o realizzati a macchina con squisita maestria, questi tappeti vantano motivi tradizionali e colori ricchi che si fondono perfettamente con qualsiasi stile di arredamento. Dai tappeti persiani con intricati motivi floreali ai kilim turchi con disegni geometrici, la nostra collezione classica offre un tocco di tradizione per la vostra casa.",
    es: "La elegancia atemporal define nuestras alfombras clásicas. Tejidas a mano o fabricadas a máquina con exquisita artesanía, estas alfombras ostentan patrones tradicionales y colores ricos que se integran perfectamente con cualquier estilo de decoración. Desde alfombras persas con intrincados motivos florales hasta kilims turcos con diseños geométricos, nuestra colección clásica ofrece un toque de herencia para su hogar."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Discover the Timeless Beauty of Classic Rugs</h2>
          <p>At YourCarpet.com, we celebrate the enduring charm of <strong>classic rugs</strong>. Our collection features a stunning array of <strong>traditional area rugs</strong> and <strong>classical carpets</strong> that bring sophistication and warmth to any space. Whether you{"'"}re looking for a <strong>traditional rug</strong> to enhance your living room or a <strong>classic area rug</strong> to anchor your dining room, our selection offers something for every home.</p>
          <p>Our <strong>classic rugs</strong> are more than just floor coverings—they{"'"}re timeless pieces of art that elevate your decor. With intricate patterns, rich colors, and premium craftsmanship, these rugs are designed to stand the test of time.</p>
        </section>

        <section>
          <h2>Why Choose Classic Rugs?</h2>
          <p>Classic rugs are a perfect choice for those who appreciate timeless design and exceptional quality. Here{"'"}s why our <strong>traditional rugs</strong> and <strong>classical carpets</strong> are a must-have for your home:</p>
          <ul>
            <li><strong>Timeless Appeal</strong>: Our <strong>classic rugs</strong> feature designs that never go out of style, making them a long-lasting addition to your home.</li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a <strong>living room</strong>, dining room, or bedroom, our <strong>traditional area rugs</strong> complement a wide range of interior styles.</li>
            <li><strong>Durability</strong>: Crafted from high-quality materials, our <strong>classical carpets</strong> are built to withstand daily wear and tear while maintaining their beauty.</li>
            <li><strong>Comfort</strong>: Our <strong>area rug traditional</strong> options are not only elegant but also soft and comfortable underfoot, making them perfect for high-traffic areas.</li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Classic Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some highlights:</p>
          <ul>
            <li><strong>Traditional Rugs for Living Room</strong>: Add a touch of elegance to your living space with our <strong>traditional rugs for living room</strong>. These rugs are designed to anchor your furniture and create a cohesive look.</li>
            <li><strong>Classical Carpets</strong>: For those who love intricate patterns and rich textures, our <strong>classical carpets</strong> offer a timeless aesthetic that enhances any room.</li>
            <li><strong>Traditional Area Rugs</strong>: Perfect for dining rooms or entryways, our <strong>traditional area rugs</strong> combine functionality with timeless design.</li>
            <li><strong>Neutral Classic Rugs</strong>: If you prefer a subtle touch, our neutral <strong>classic rugs</strong> feature soft tones and elegant patterns that blend effortlessly with any decor.</li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Classic Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>traditional rug</strong> to add character to your space or a <strong>classic area rug</strong> to create a focal point, YourCarpet.com has you covered. Our collection includes a variety of sizes, from small accent rugs to large statement pieces, ensuring you{"'"}ll find the perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>classic rug</strong> to transform your home. With their timeless designs and exceptional quality, our <strong>traditional rugs</strong> and <strong>classical carpets</strong> are sure to become cherished pieces in your decor.</p>
        </section>
      </>
    ),
    es: (
      <>
        <section>
          <h2>Descubre la Belleza Atemporal de las Alfombras Clásicas</h2>
          <p>En YourCarpet.com, celebramos el encanto perdurable de las <strong>alfombras clásicas</strong>. Nuestra colección presenta una impresionante variedad de <strong>alfombras tradicionales</strong> y <strong>tapetes clásicos</strong> que aportan sofisticación y calidez a cualquier espacio. Ya sea que busques una <strong>alfombra tradicional</strong> para realzar tu sala de estar o una <strong>alfombra clásica de área</strong> para anclar tu comedor, nuestra selección ofrece algo para cada hogar.</p>
          <p>Nuestras <strong>alfombras clásicas</strong> son más que simples revestimientos para el suelo; son piezas de arte atemporales que elevan tu decoración. Con patrones intrincados, colores ricos y fabricación premium, estas alfombras están diseñadas para resistir el paso del tiempo.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Clásicas?</h2>
          <p>Las alfombras clásicas son una elección perfecta para quienes aprecian el diseño atemporal y la calidad excepcional. Estas son las razones por las que nuestras <strong>alfombras tradicionales</strong> y <strong>tapetes clásicos</strong> son imprescindibles para tu hogar:</p>
          <ul>
            <li><strong>Atractivo Atemporal</strong>: Nuestras <strong>alfombras clásicas</strong> presentan diseños que nunca pasan de moda, convirtiéndolas en una adición duradera para tu hogar.</li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una <strong>sala de estar</strong>, comedor o dormitorio, nuestras <strong>alfombras tradicionales de área</strong> complementan una amplia gama de estilos de interior.</li>
            <li><strong>Durabilidad</strong>: Elaborados con materiales de alta calidad, nuestros <strong>tapetes clásicos</strong> están construidos para soportar el desgaste diario mientras mantienen su belleza.</li>
            <li><strong>Comodidad</strong>: Nuestras opciones de <strong>alfombra tradicional de área</strong> no solo son elegantes sino también suaves y cómodas al tacto, haciéndolas perfectas para áreas de alto tráfico.</li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Clásicas</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores que se adaptan a tus necesidades. Aquí hay algunos aspectos destacados:</p>
          <ul>
            <li><strong>Alfombras Tradicionales para Sala de Estar</strong>: Añade un toque de elegancia a tu espacio de vida con nuestras <strong>alfombras tradicionales para sala de estar</strong>. Estas alfombras están diseñadas para anclar tus muebles y crear un aspecto cohesivo.</li>
            <li><strong>Tapetes Clásicos</strong>: Para aquellos que aman los patrones intrincados y las texturas ricas, nuestros <strong>tapetes clásicos</strong> ofrecen una estética atemporal que realza cualquier habitación.</li>
            <li><strong>Alfombras Tradicionales de Área</strong>: Perfectas para comedores o entradas, nuestras <strong>alfombras tradicionales de área</strong> combinan funcionalidad con diseño atemporal.</li>
            <li><strong>Alfombras Clásicas Neutras</strong>: Si prefieres un toque sutil, nuestras <strong>alfombras clásicas</strong> neutras presentan tonos suaves y patrones elegantes que se mezclan sin esfuerzo con cualquier decoración.</li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Clásica Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra tradicional</strong> para añadir carácter a tu espacio o una <strong>alfombra clásica de área</strong> para crear un punto focal, YourCarpet.com te tiene cubierto. Nuestra colección incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de declaración, asegurando que encontrarás el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra clásica</strong> perfecta para transformar tu hogar. Con sus diseños atemporales y calidad excepcional, nuestras <strong>alfombras tradicionales</strong> y <strong>tapetes clásicos</strong> seguramente se convertirán en piezas apreciadas en tu decoración.</p>
        </section>
      </>
    )
  },
  htmlHead: {
    title: {
      en: 'Classic Rugs Collection',
      es: 'Colección de Alfombras Clásicas',
    },
    subtitle: {
      en: 'Timeless Elegance for Your Home',
      es: 'Elegancia Atemporal para su Hogar',
    },
    description: {
      en: 'Discover our timeless collection of classic rugs at YourCarpet.com. From traditional area rugs to classical carpets, find the perfect rug for your living room, dining room, or any space. Shop now!',
      es: 'Descubra nuestra colección atemporal de alfombras clásicas en YourCarpet.com. Desde alfombras de área tradicionales hasta tapetes clásicos, encuentre la alfombra perfecta para su sala, comedor o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['classic rugs', 'classic rug', 'classic area rugs', 'classical carpets', 'traditional area rugs', 'traditional rugs', 'traditional rug', 'traditional area rug', 'area rug traditional', 'traditional rugs for living room'],
      es: ['alfombras clásicas', 'alfombra clásica', 'alfombras de área clásicas', 'tapetes clásicos', 'alfombras de área tradicionales', 'alfombras tradicionales', 'alfombra tradicional', 'alfombra de área tradicional', 'alfombra de área tradicional', 'alfombras tradicionales para sala']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our timeless collection of classic rugs. Perfect for adding elegance and sophistication to your home. Shop traditional and classical rugs for every room.',
      es: 'Explore nuestra colección atemporal de alfombras clásicas. Perfectas para añadir elegancia y sofisticación a su hogar. Compre alfombras tradicionales y clásicas para cada habitación.'
    },
    twitter: {
      en: 'Discover our timeless classic rugs collection. Perfect for living rooms, dining rooms, and more. Shop now!',
      es: 'Descubra nuestra colección de alfombras clásicas atemporales. Perfectas para salas, comedores y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of classic rugs, including traditional area rugs and classical carpets. Perfect for adding elegance to any room in your home.',
      es: 'Explore nuestra amplia gama de alfombras clásicas, incluyendo alfombras de área tradicionales y tapetes clásicos. Perfectas para añadir elegancia a cualquier habitación de su hogar.'
    }
  }
});

// Modern
stylesCodes.addData(1, {
  name: { en: 'modern', fr: 'moderne', it: 'moderno', es: 'moderno' },
  summary: {
    en: 'Inject contemporary flair into your space with our modern rugs. Featuring bold geometric patterns, vibrant color palettes, and innovative materials, these rugs are perfect for creating a statement. Explore our collection of abstract designs, solid color rugs with a luxurious texture, or modern takes on traditional motifs.',
    fr: "Injectez une touche contemporaine dans votre espace avec nos tapis modernes. Présentant des motifs géométriques audacieux, des palettes de couleurs vibrantes et des matériaux innovants, ces tapis sont parfaits pour créer une déclaration. Explorez notre collection de designs abstraits, de tapis unis avec une texture luxueuse, ou des interprétations modernes de motifs traditionnels.",
    it: "Iniettate un tocco contemporaneo nel vostro spazio con i nostri tappeti moderni. Con audaci motivi geometrici, vivaci palette di colori e materiali innovativi, questi tappeti sono perfetti per creare una dichiarazione d'intenti. Esplorate la nostra collezione di design astratti, tappeti in tinta unita con una texture lussuosa, o interpretazioni moderne di motivi tradizionali.",
    es: "Inyecte un toque contemporáneo en su espacio con nuestras alfombras modernas. Con patrones geométricos audaces, paletas de colores vibrantes y materiales innovadores, estas alfombras son perfectas para crear una declaración. Explore nuestra colección de diseños abstractos, alfombras de color sólido con una textura lujosa, o interpretaciones modernas de motivos tradicionales."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Transform Your Space with Modern Rugs</h2>
          <p>At YourCarpet.com, we bring you a curated collection of <strong>modern rugs</strong> that redefine
            contemporary design. Whether you{"'"}re looking for <strong>cool rugs</strong> to make a bold statement
            or <strong>simple modern rugs</strong> to complement minimalist decor, our collection has something for
            every taste. Explore our <strong>all modern rugs</strong> and discover the perfect piece to elevate your
            home.</p>
          <p>Our <strong>modern carpets</strong> are designed to blend functionality with style, offering a perfect
            balance of comfort and aesthetics. From <strong>rugs modern</strong> in vibrant colors to <strong>carpet
              modern</strong> in neutral tones, each rug is crafted to enhance your living space.</p>
        </section>

        <section>
          <h2>Why Choose Modern Rugs?</h2>
          <p>Modern rugs are the perfect choice for those who love clean lines, bold patterns, and contemporary design.
            Here{"'"}s why our <strong>modern rugs</strong> stand out:</p>
          <ul>
            <li><strong>Contemporary Style</strong>: Our <strong>allmodern rug</strong> collection features sleek
              designs that add a modern touch to any room.
            </li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a living room, bedroom, or office, our <strong>modern
              rugs</strong> complement a wide range of interior styles.
            </li>
            <li><strong>Durability</strong>: Made from high-quality materials, our <strong>modern carpets</strong> are
              built to last, ensuring they remain a centerpiece in your home for years to come.
            </li>
            <li><strong>Comfort</strong>: Our <strong>rugs modern</strong> are not only stylish but also soft and
              comfortable underfoot, making them perfect for high-traffic areas.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Modern Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some
            highlights:</p>
          <ul>
            <li><strong>Cool Rugs</strong>: Add a touch of personality to your space with our <strong>cool rugs</strong>,
              featuring bold patterns and vibrant colors.
            </li>
            <li><strong>Simple Modern Rugs</strong>: For a minimalist look, our <strong>simple modern
              rugs</strong> offer clean lines and understated elegance.
            </li>
            <li><strong>All Modern Rugs</strong>: Explore our <strong>all modern rugs</strong> collection, featuring a
              variety of contemporary designs to suit every taste.
            </li>
            <li><strong>Modern Carpets</strong>: Perfect for larger spaces, our <strong>modern carpets</strong> make a
              bold statement with their sleek patterns and premium craftsmanship.
            </li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Modern Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>modern rug</strong> to add a pop of color to your living room or
            a <strong>carpet modern</strong> to anchor your dining room, YourCarpet.com has you covered. Our collection
            includes a variety of sizes, from small accent rugs to large statement pieces, ensuring you{"'"}ll find the
            perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>modern rug</strong> to transform your space.
            With their contemporary designs and exceptional quality, our <strong>modern rugs</strong> are sure to become
            a cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for Timeless Elegance?</h2>
          <p>If you prefer a more traditional aesthetic, check out our <a
            href="https://www.yourcarpet.com/en/shop/carpets?styles=classic">Classic Rugs Collection</a>. Featuring
            timeless designs and intricate patterns, our <strong>classic rugs</strong> are perfect for adding elegance
            and sophistication to any room.</p>
        </section>
      </>
    ),
    es: (
      <>
        <section>
          <h2>Transforma Tu Espacio con Alfombras Modernas</h2>
          <p>En YourCarpet.com, te ofrecemos una colección exclusiva de <strong>alfombras modernas</strong> que redefinen
            el diseño contemporáneo. Ya sea que busques <strong>alfombras originales</strong> para hacer una declaración
            audaz o <strong>alfombras modernas sencillas</strong> para complementar una decoración minimalista, nuestra
            colección tiene algo para todos los gustos. Explora nuestras <strong>alfombras totalmente modernas</strong> y
            descubre la pieza perfecta para elevar tu hogar.</p>
          <p>Nuestras <strong>alfombras modernas</strong> están diseñadas para combinar funcionalidad con estilo, ofreciendo
            un equilibrio perfecto entre comodidad y estética. Desde <strong>alfombras modernas</strong> en colores vibrantes
            hasta <strong>moquetas modernas</strong> en tonos neutros, cada alfombra está elaborada para mejorar tu espacio
            de vida.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Modernas?</h2>
          <p>Las alfombras modernas son la elección perfecta para quienes aman las líneas limpias, los patrones audaces y
            el diseño contemporáneo. Estas son las razones por las que nuestras <strong>alfombras modernas</strong> se
            destacan:</p>
          <ul>
            <li><strong>Estilo Contemporáneo</strong>: Nuestra colección de <strong>alfombras ultramodernas</strong> presenta
              diseños elegantes que añaden un toque moderno a cualquier habitación.
            </li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una sala de estar, un dormitorio o una oficina,
              nuestras <strong>alfombras modernas</strong> complementan una amplia gama de estilos de interior.
            </li>
            <li><strong>Durabilidad</strong>: Fabricadas con materiales de alta calidad, nuestras <strong>alfombras modernas</strong>
              están construidas para durar, asegurando que permanezcan como pieza central en tu hogar durante años.
            </li>
            <li><strong>Comodidad</strong>: Nuestras <strong>alfombras modernas</strong> no solo son elegantes sino también
              suaves y cómodas al pisar, haciéndolas perfectas para áreas de alto tráfico.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Modernas</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí
            algunos destacados:</p>
          <ul>
            <li><strong>Alfombras Originales</strong>: Añade un toque de personalidad a tu espacio con nuestras <strong>alfombras
              originales</strong>, con patrones audaces y colores vibrantes.
            </li>
            <li><strong>Alfombras Modernas Sencillas</strong>: Para un look minimalista, nuestras <strong>alfombras modernas
              sencillas</strong> ofrecen líneas limpias y elegancia discreta.
            </li>
            <li><strong>Alfombras Totalmente Modernas</strong>: Explora nuestra colección de <strong>alfombras totalmente
              modernas</strong>, con una variedad de diseños contemporáneos para todos los gustos.
            </li>
            <li><strong>Moquetas Modernas</strong>: Perfectas para espacios más grandes, nuestras <strong>moquetas
              modernas</strong> hacen una declaración audaz con sus patrones elegantes y artesanía premium.
            </li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Moderna Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra moderna</strong> para añadir un toque de color a tu sala de
            estar o una <strong>moqueta moderna</strong> para anclar tu comedor, YourCarpet.com te tiene cubierto. Nuestra
            colección incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de
            declaración, asegurando que encontrarás el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra moderna</strong> perfecta para transformar tu
            espacio. Con sus diseños contemporáneos y calidad excepcional, nuestras <strong>alfombras modernas</strong>
            seguramente se convertirán en una parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas Elegancia Atemporal?</h2>
          <p>Si prefieres una estética más tradicional, echa un vistazo a nuestra <a
            href="https://www.yourcarpet.com/es/shop/carpets?styles=classic">Colección de Alfombras Clásicas</a>. Con
            diseños atemporales y patrones intrincados, nuestras <strong>alfombras clásicas</strong> son perfectas para
            añadir elegancia y sofisticación a cualquier habitación.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Modern Rugs Collection',
      es: 'Colección de Alfombras Modernas'
    },
    subtitle: {
      en: 'Sleek, Stylish, and Contemporary',
      es: 'Elegante, Estilizada y Contemporánea',
    },
    description: {
      en: 'Discover our sleek collection of modern rugs at YourCarpet.com. From cool rugs to simple modern rugs, find the perfect contemporary piece for your living room, bedroom, or any space. Shop now!',
      es: 'Descubra nuestra elegante colección de alfombras modernas en YourCarpet.com. Desde alfombras cool hasta alfombras modernas simples, encuentre la pieza contemporánea perfecta para su sala, dormitorio o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['modern rugs', 'modern rug', 'cool rugs', 'all modern rugs', 'rugs modern', 'modern carpets', 'carpet modern', 'allmodern rug', 'simple modern rugs'],
      es: ['alfombras modernas', 'alfombra moderna', 'alfombras cool', 'todas las alfombras modernas', 'alfombras modernas', 'tapetes modernos', 'tapete moderno', 'alfombra allmodern', 'alfombras modernas simples']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our stylish collection of modern rugs. Perfect for adding a contemporary touch to your home. Shop cool rugs, simple modern rugs, and more.',
      es: 'Explore nuestra estilizada colección de alfombras modernas. Perfectas para añadir un toque contemporáneo a su hogar. Compre alfombras cool, alfombras modernas simples y más.'
    },
    twitter: {
      en: 'Discover our sleek modern rugs collection. Perfect for living rooms, bedrooms, and more. Shop now!',
      es: 'Descubra nuestra elegante colección de alfombras modernas. Perfectas para salas, dormitorios y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of modern rugs, including cool rugs, simple modern rugs, and contemporary designs. Perfect for adding a modern touch to any room in your home.',
      es: 'Explore nuestra amplia gama de alfombras modernas, incluyendo alfombras cool, alfombras modernas simples y diseños contemporáneos. Perfectas para añadir un toque moderno a cualquier habitación de su hogar.'
    }
  }
});

// Rustic
stylesCodes.addData(2, {
  name: {en: 'rustic', fr: 'rustique', it: 'rustico', es: 'rústico'},
  summary: {
    en: 'Discover our handcrafted rustic rugs, made with natural fibers like wool. These artisan and nomadic rugs use natural dyes to create earth-toned masterpieces. Our cozy collection features simple patterns inspired by the countryside, bringing warmth to your space. Experience the charm of authentic, handcrafted rugs in your home or office.',
    fr: "Découvrez nos tapis rustiques faits main, confectionnés avec des fibres naturelles comme la laine. Ces tapis artisanaux et nomades utilisent des teintures naturelles pour créer des chefs-d'œuvre aux tons terreux. Notre collection chaleureuse présente des motifs simples inspirés de la campagne, apportant de la chaleur à votre espace. Faites l'expérience du charme des tapis authentiques et artisanaux dans votre maison ou votre bureau.",
    it: "Scoprite i nostri tappeti rustici artigianali, realizzati con fibre naturali come la lana. Questi tappeti artigianali e nomadi utilizzano tinte naturali per creare capolavori dai toni terrosi. La nostra accogliente collezione presenta semplici motivi ispirati alla campagna, portando calore al vostro spazio. Sperimentate il fascino dei tappeti autentici e artigianali nella vostra casa o ufficio.",
    es: 'Descubra nuestras alfombras rústicas hechas a mano, confeccionadas con fibras naturales como la lana. Estas alfombras artesanales y nómadas utilizan tintes naturales para crear obras maestras de tonos terrosos. Nuestra acogedora colección presenta patrones sencillos inspirados en el campo, aportando calidez a su espacio. Experimente el encanto de las alfombras auténticas y artesanales en su hogar u oficina.'
  },
  text: {
    en: (
      <>
        <section>
          <h2>Bring Cozy Charm to Your Space with Rustic Rugs</h2>
          <p>At YourCarpet.com, we celebrate the timeless appeal of <strong>rustic rugs</strong>. Our collection
            features a stunning array of <strong>rustic area rugs</strong>, <strong>cabin rustic rugs</strong>,
            and <strong>rustic log cabin rugs</strong> that bring warmth and character to any space. Whether you{"'"}re
            decorating a cozy cabin, a farmhouse living room, or a rustic-themed bedroom, our rugs are designed to
            enhance your decor with their natural charm.</p>
          <p>Our <strong>rustic rugs</strong> are more than just floor coverings—they{"'"}re pieces of art that tell a
            story. With earthy tones, natural textures, and durable craftsmanship, these rugs are perfect for creating a
            welcoming and inviting atmosphere.</p>
        </section>

        <section>
          <h2>Why Choose Rustic Rugs?</h2>
          <p>Rustic rugs are the perfect choice for those who love the warmth and charm of natural materials and earthy
            designs. Here{"'"}s why our <strong>rustic rugs</strong> stand out:</p>
          <ul>
            <li><strong>Timeless Appeal</strong>: Our <strong>rustic rugs</strong> feature designs inspired by nature,
              making them a timeless addition to any home.
            </li>
            <li><strong>Durability</strong>: Crafted from high-quality materials, our <strong>rustic area
              rugs</strong> are built to withstand daily wear and tear, making them perfect for high-traffic areas.
            </li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a cabin, living room, or bedroom, our <strong>rustic
              rugs</strong> complement a wide range of interior styles.
            </li>
            <li><strong>Comfort</strong>: Our <strong>area rug rustic</strong> options are not only stylish but also
              soft and comfortable underfoot, adding warmth to your space.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Rustic Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some
            highlights:</p>
          <ul>
            <li><strong>Cabin Rustic Rugs</strong>: Add a touch of charm to your cabin with our <strong>cabin rustic
              rugs</strong>, featuring natural textures and earthy tones.
            </li>
            <li><strong>Rustic Area Rugs 8x10</strong>: Perfect for larger spaces, our <strong>rustic 8 x 10 area
              rugs</strong> make a bold statement with their cozy designs.
            </li>
            <li><strong>Rustic Log Cabin Rugs</strong>: Inspired by the great outdoors, our <strong>rustic log cabin
              rugs</strong> bring the beauty of nature into your home.
            </li>
            <li><strong>8x10 Rustic Rug</strong>: Ideal for spacious rooms, our <strong>8x10 rustic rug</strong> options
              offer both style and functionality.
            </li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Rustic Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>rustic rug</strong> to add warmth to your cabin or a <strong>rustic
            area rug</strong> to anchor your living room, YourCarpet.com has you covered. Our collection includes a
            variety of sizes, from small accent rugs to large statement pieces, ensuring you{"'"}ll find the perfect fit for
            your home.</p>
          <p>Explore our collection today and discover the perfect <strong>rustic rug</strong> to transform your space.
            With their natural charm and exceptional quality, our <strong>rustic rugs</strong> are sure to become a
            cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for a Contemporary Touch?</h2>
          <p>If you{"'"}re drawn to sleek, modern designs, check out our <a
            href="https://www.yourcarpet.com/en/shop/carpets?styles=modern">Modern Rugs Collection</a>. Featuring bold
            patterns and contemporary styles, our <strong>modern rugs</strong> are perfect for adding a fresh, modern
            touch to any room.</p>
        </section>

      </>
    ),
    es: (
      <>
        <section>
          <h2>Añade un Encanto Acogedor a Tu Espacio con Alfombras Rústicas</h2>
          <p>En YourCarpet.com, celebramos el atractivo atemporal de las <strong>alfombras rústicas</strong>. Nuestra colección
            presenta una impresionante variedad de <strong>alfombras de área rústicas</strong>, <strong>alfombras rústicas de cabaña</strong>,
            y <strong>alfombras rústicas estilo cabaña de madera</strong> que aportan calidez y carácter a cualquier espacio. Ya sea que estés
            decorando una acogedora cabaña, una sala de estar campestre, o un dormitorio de temática rústica, nuestras alfombras están diseñadas para
            realzar tu decoración con su encanto natural.</p>
          <p>Nuestras <strong>alfombras rústicas</strong> son más que simples coberturas para el suelo—son piezas de arte que cuentan una
            historia. Con tonos terrosos, texturas naturales y artesanía duradera, estas alfombras son perfectas para crear una
            atmósfera acogedora e invitadora.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Rústicas?</h2>
          <p>Las alfombras rústicas son la elección perfecta para quienes aman la calidez y el encanto de los materiales naturales y los
            diseños terrosos. Estas son las razones por las que nuestras <strong>alfombras rústicas</strong> se destacan:</p>
          <ul>
            <li><strong>Atractivo Atemporal</strong>: Nuestras <strong>alfombras rústicas</strong> presentan diseños inspirados en la naturaleza,
              convirtiéndolas en una adición atemporal para cualquier hogar.
            </li>
            <li><strong>Durabilidad</strong>: Elaboradas con materiales de alta calidad, nuestras <strong>alfombras de área
              rústicas</strong> están construidas para resistir el desgaste diario, haciéndolas perfectas para áreas de alto tráfico.
            </li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una cabaña, sala de estar o dormitorio, nuestras <strong>alfombras
              rústicas</strong> complementan una amplia gama de estilos de interior.
            </li>
            <li><strong>Comodidad</strong>: Nuestras opciones de <strong>alfombras rústicas de área</strong> no solo son elegantes sino también
              suaves y cómodas al pisar, añadiendo calidez a tu espacio.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Rústicas</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos
            destacados:</p>
          <ul>
            <li><strong>Alfombras Rústicas de Cabaña</strong>: Añade un toque de encanto a tu cabaña con nuestras <strong>alfombras rústicas
              de cabaña</strong>, con texturas naturales y tonos terrosos.
            </li>
            <li><strong>Alfombras Rústicas de Área 8x10</strong>: Perfectas para espacios más grandes, nuestras <strong>alfombras de área
              rústicas 8 x 10</strong> hacen una declaración audaz con sus diseños acogedores.
            </li>
            <li><strong>Alfombras Rústicas Estilo Cabaña de Madera</strong>: Inspiradas en la naturaleza, nuestras <strong>alfombras rústicas
              estilo cabaña de madera</strong> traen la belleza de la naturaleza a tu hogar.
            </li>
            <li><strong>Alfombra Rústica 8x10</strong>: Ideales para habitaciones espaciosas, nuestras opciones de <strong>alfombra rústica
              8x10</strong> ofrecen tanto estilo como funcionalidad.
            </li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Rústica Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra rústica</strong> para añadir calidez a tu cabaña o una <strong>alfombra de área
            rústica</strong> para anclar tu sala de estar, YourCarpet.com te tiene cubierto. Nuestra colección incluye una
            variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de declaración, asegurando que encontrarás
            el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra rústica</strong> perfecta para transformar tu espacio.
            Con su encanto natural y calidad excepcional, nuestras <strong>alfombras rústicas</strong> seguramente se convertirán en una
            parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas un Toque Contemporáneo?</h2>
          <p>Si te atraen los diseños elegantes y modernos, echa un vistazo a nuestra <a
            href="https://www.yourcarpet.com/es/shop/carpets?styles=modern">Colección de Alfombras Modernas</a>. Con
            patrones audaces y estilos contemporáneos, nuestras <strong>alfombras modernas</strong> son perfectas para añadir un toque
            fresco y moderno a cualquier habitación.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Rustic Rugs Collection',
      es: 'Colección de Alfombras Rústicas'
    },
    subtitle: {
      en: 'Warmth, Charm, and Timeless Appeal',
      es: 'Calidez, Encanto y Atractivo Atemporal',
    },
    description: {
      en: 'Discover our cozy collection of rustic rugs at YourCarpet.com. From cabin rustic rugs to rustic area rugs 8x10, find the perfect piece for your cabin, living room, or any space. Shop now!',
      es: 'Descubra nuestra acogedora colección de alfombras rústicas en YourCarpet.com. Desde alfombras rústicas para cabañas hasta alfombras de área rústicas 8x10, encuentre la pieza perfecta para su cabaña, sala de estar o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['rustic area rugs', 'rustic rugs', 'cabin rustic rugs', 'rustic rug', 'rustic log cabin rugs', 'rustic rugs for cabins', 'rustic 8 x 10 area rugs', 'area rug rustic', 'rustic area rugs 8x10', 'rustic rugs for cabin', '8x10 rustic rug'],
      es: ['alfombras de área rústicas', 'alfombras rústicas', 'alfombras rústicas para cabañas', 'alfombra rústica', 'alfombras rústicas para cabañas de troncos', 'alfombras rústicas para cabañas', 'alfombras de área rústicas 8 x 10', 'alfombra de área rústica', 'alfombras de área rústicas 8x10', 'alfombras rústicas para cabaña', 'alfombra rústica 8x10']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our cozy collection of rustic rugs. Perfect for adding warmth and charm to cabins, living rooms, and more. Shop rustic area rugs, cabin rugs, and more.',
      es: 'Explore nuestra acogedora colección de alfombras rústicas. Perfectas para añadir calidez y encanto a cabañas, salas de estar y más. Compre alfombras de área rústicas, alfombras para cabañas y más.'
    },
    twitter: {
      en: 'Discover our cozy rustic rugs collection. Perfect for cabins, living rooms, and more. Shop now!',
      es: 'Descubra nuestra acogedora colección de alfombras rústicas. Perfectas para cabañas, salas de estar y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of rustic rugs, including cabin rustic rugs, rustic area rugs 8x10, and more. Perfect for adding warmth and charm to any space.',
      es: 'Explore nuestra amplia gama de alfombras rústicas, incluyendo alfombras rústicas para cabañas, alfombras de área rústicas 8x10 y más. Perfectas para añadir calidez y encanto a cualquier espacio.'
    }
  }
});

// Patchwork
stylesCodes.addData(3, {
  name: {en: 'patchwork', fr: 'patchwork', it: 'patchwork', es: 'patchwork'},
  summary: {
    en: 'Celebrate individuality with our unique patchwork rugs. Each piece is meticulously crafted from a blend of recycled fabrics and textiles, creating a one-of-a-kind statement. Explore vibrant color combinations, eclectic patterns, and a touch of vintage charm with our patchwork collection.',
    fr: "Célébrez l'individualité avec nos tapis patchwork uniques. Chaque pièce est méticuleusement conçue à partir d'un mélange de tissus et de textiles recyclés, créant une déclaration unique. Explorez des combinaisons de couleurs vibrantes, des motifs éclectiques et une touche de charme vintage avec notre collection patchwork.",
    it: "Celebrate l'individualità con i nostri tappeti patchwork unici. Ogni pezzo è meticolosamente realizzato con un mix di tessuti riciclati, creando una dichiarazione unica nel suo genere. Esplorate vivaci combinazioni di colori, motivi eclettici e un tocco di fascino vintage con la nostra collezione patchwork.",
    es: "Celebre la individualidad con nuestras alfombras de patchwork únicas. Cada pieza está meticulosamente elaborada a partir de una mezcla de telas y textiles reciclados, creando una declaración única. Explore combinaciones de colores vibrantes, patrones eclécticos y un toque de encanto vintage con nuestra colección de patchwork."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Add Character to Your Space with Patchwork Rugs</h2>
          <p>At YourCarpet.com, we bring you a one-of-a-kind collection of <strong>patchwork rugs</strong> that
            celebrate artistry and individuality. Whether you{"'"}re looking for an <strong>antique patchwork
              rug</strong> with a rich history or a modern <strong>patchwork area rug</strong> with vibrant designs, our
            collection has something for every taste. Explore our <strong>patchwork rugs</strong> and discover the
            perfect piece to add character and charm to your home.</p>
          <p>Our <strong>patchwork rugs</strong> are more than just floor coverings—they{"'"}re works of art that tell a
            story. With their unique patterns, vibrant colors, and intricate designs, these rugs are perfect for
            creating a focal point in any room.</p>
        </section>

        <section>
          <h2>Why Choose Patchwork Rugs?</h2>
          <p>Patchwork rugs are the perfect choice for those who love unique, artistic designs and a touch of history.
            Here{"'"}s why our <strong>patchwork rugs</strong> stand out:</p>
          <ul>
            <li><strong>Unique Designs</strong>: Each <strong>patchwork rug</strong> is a masterpiece, featuring a blend
              of patterns, colors, and textures that make it one-of-a-kind.
            </li>
            <li><strong>Artistic Appeal</strong>: Our <strong>rug patchwork</strong> collection showcases the artistry
              of traditional and modern designs, perfect for adding character to your space.
            </li>
            <li><strong>Durability</strong>: Crafted from high-quality materials, our <strong>patchwork area
              rugs</strong> are built to last, ensuring they remain a centerpiece in your home for years to come.
            </li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a living room, bedroom, or dining room,
              our <strong>patchwork rugs</strong> complement a wide range of interior styles.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Patchwork Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some
            highlights:</p>
          <ul>
            <li><strong>Antique Patchwork Rugs</strong>: Add a touch of history to your home with our <strong>antique
              patchwork rugs</strong>, featuring intricate designs and rich colors.
            </li>
            <li><strong>Patchwork Area Rugs</strong>: Perfect for larger spaces, our <strong>patchwork area
              rugs</strong> make a bold statement with their vibrant patterns and textures.
            </li>
            <li><strong>Modern Patchwork Rugs</strong>: For a contemporary look, our <strong>patchwork
              rugs</strong> offer sleek designs and vibrant colors that add a modern touch to any room.
            </li>
            <li><strong>Small Patchwork Rugs</strong>: Ideal for accent spaces, our smaller <strong>patchwork
              rugs</strong> add a pop of color and character to any corner of your home.
            </li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Patchwork Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for an <strong>antique patchwork rug</strong> to add a touch of history to your
            living room or a <strong>patchwork area rug</strong> to anchor your dining room, YourCarpet.com has you
            covered. Our collection includes a variety of sizes, from small accent rugs to large statement pieces,
            ensuring you{"'"}ll find the perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>patchwork rug</strong> to transform your
            space. With their unique designs and exceptional quality, our <strong>patchwork rugs</strong> are sure to
            become a cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for Rustic Charm?</h2>
          <p>If you{"'"}re drawn to the warmth and charm of natural designs, check out our <a
            href="https://www.yourcarpet.com/en/shop/carpets?styles=rustic">Rustic Rugs Collection</a>. Featuring earthy
            tones and natural textures, our <strong>rustic rugs</strong> are perfect for adding warmth and character to
            any space.</p>
        </section>

      </>
    ),
    es: (
      <>
        <section>
          <h2>Añade Carácter a Tu Espacio con Alfombras Patchwork</h2>
          <p>En YourCarpet.com, te ofrecemos una colección única de <strong>alfombras patchwork</strong> que
            celebran el arte y la individualidad. Ya sea que estés buscando una <strong>alfombra patchwork
              antigua</strong> con una rica historia o una moderna <strong>alfombra de área patchwork</strong> con diseños vibrantes, nuestra
            colección tiene algo para todos los gustos. Explora nuestras <strong>alfombras patchwork</strong> y descubre la
            pieza perfecta para añadir carácter y encanto a tu hogar.</p>
          <p>Nuestras <strong>alfombras patchwork</strong> son más que simples coberturas para el suelo—son obras de arte que cuentan una
            historia. Con sus patrones únicos, colores vibrantes y diseños intrincados, estas alfombras son perfectas para
            crear un punto focal en cualquier habitación.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Patchwork?</h2>
          <p>Las alfombras patchwork son la elección perfecta para quienes aman los diseños artísticos únicos y un toque de historia.
            Estas son las razones por las que nuestras <strong>alfombras patchwork</strong> se destacan:</p>
          <ul>
            <li><strong>Diseños Únicos</strong>: Cada <strong>alfombra patchwork</strong> es una obra maestra, con una mezcla
              de patrones, colores y texturas que la hacen única en su tipo.
            </li>
            <li><strong>Atractivo Artístico</strong>: Nuestra colección de <strong>alfombras tipo patchwork</strong> muestra la maestría
              de los diseños tradicionales y modernos, perfecta para añadir carácter a tu espacio.
            </li>
            <li><strong>Durabilidad</strong>: Elaboradas con materiales de alta calidad, nuestras <strong>alfombras de área
              patchwork</strong> están construidas para durar, asegurando que permanezcan como pieza central en tu hogar durante años.
            </li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una sala de estar, un dormitorio o un comedor,
              nuestras <strong>alfombras patchwork</strong> complementan una amplia gama de estilos de interior.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Patchwork</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos
            destacados:</p>
          <ul>
            <li><strong>Alfombras Patchwork Antiguas</strong>: Añade un toque de historia a tu hogar con nuestras <strong>alfombras
              patchwork antiguas</strong>, con diseños intrincados y colores ricos.
            </li>
            <li><strong>Alfombras de Área Patchwork</strong>: Perfectas para espacios más grandes, nuestras <strong>alfombras de área
              patchwork</strong> hacen una declaración audaz con sus patrones vibrantes y texturas.
            </li>
            <li><strong>Alfombras Patchwork Modernas</strong>: Para un look contemporáneo, nuestras <strong>alfombras
              patchwork</strong> ofrecen diseños elegantes y colores vibrantes que añaden un toque moderno a cualquier habitación.
            </li>
            <li><strong>Alfombras Patchwork Pequeñas</strong>: Ideales para espacios de acento, nuestras <strong>alfombras
              patchwork</strong> más pequeñas añaden un toque de color y carácter a cualquier rincón de tu hogar.
            </li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Patchwork Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra patchwork antigua</strong> para añadir un toque de historia a tu
            sala de estar o una <strong>alfombra de área patchwork</strong> para anclar tu comedor, YourCarpet.com te tiene
            cubierto. Nuestra colección incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas
            de declaración, asegurando que encontrarás el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra patchwork</strong> perfecta para transformar tu
            espacio. Con sus diseños únicos y calidad excepcional, nuestras <strong>alfombras patchwork</strong> seguramente se
            convertirán en una parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas un Encanto Rústico?</h2>
          <p>Si te atraen la calidez y el encanto de los diseños naturales, echa un vistazo a nuestra <a
            href="https://www.yourcarpet.com/es/shop/carpets?styles=rustic">Colección de Alfombras Rústicas</a>. Con tonos
            terrosos y texturas naturales, nuestras <strong>alfombras rústicas</strong> son perfectas para añadir calidez y carácter a
            cualquier espacio.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Patchwork Rugs Collection',
      es: 'Colección de Alfombras de Patchwork'
    },
    subtitle: {
      en: 'Unique, Artistic, and Full of Character',
      es: 'Únicas, Artísticas y Llenas de Carácter',
    },
    description: {
      en: 'Discover our unique collection of patchwork rugs at YourCarpet.com. From antique patchwork rugs to modern patchwork area rugs, find the perfect piece for your living room, bedroom, or any space. Shop now!',
      es: 'Descubra nuestra colección única de alfombras de patchwork en YourCarpet.com. Desde alfombras de patchwork antiguas hasta alfombras de área de patchwork modernas, encuentre la pieza perfecta para su sala de estar, dormitorio o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['patchwork rug', 'rug patchwork', 'patchwork area rug', 'patchwork area rugs', 'patchwork rugs', 'antique patchwork rug', 'antique patchwork rugs'],
      es: ['alfombra de patchwork', 'alfombra patchwork', 'alfombra de área patchwork', 'alfombras de área patchwork', 'alfombras de patchwork', 'alfombra de patchwork antigua', 'alfombras de patchwork antiguas']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our unique collection of patchwork rugs. Perfect for adding character and charm to your home. Shop antique patchwork rugs, modern patchwork area rugs, and more.',
      es: 'Explore nuestra colección única de alfombras de patchwork. Perfectas para añadir carácter y encanto a su hogar. Compre alfombras de patchwork antiguas, alfombras de área de patchwork modernas y más.'
    },
    twitter: {
      en: 'Discover our unique patchwork rugs collection. Perfect for living rooms, bedrooms, and more. Shop now!',
      es: 'Descubra nuestra colección única de alfombras de patchwork. Perfectas para salas de estar, dormitorios y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of patchwork rugs, including antique patchwork rugs and modern patchwork area rugs. Perfect for adding character and charm to any space.',
      es: 'Explore nuestra amplia gama de alfombras de patchwork, incluyendo alfombras de patchwork antiguas y alfombras de área de patchwork modernas. Perfectas para añadir carácter y encanto a cualquier espacio.'
    }
  }
});

// Kilim/sumak
stylesCodes.addData(4, {
  name: {en: 'kilim/sumak', fr: 'kilim/sumak', it: 'kilim/sumak', es: 'kilim/sumak'},
  summary: {
    en: 'Experience the rich tradition of flat-woven rugs with our Kilim and Sumak collections. Handcrafted by skilled artisans, these rugs showcase vibrant colors, geometric patterns, and a beautiful flat weave construction. Explore bold tribal designs, intricate motifs, and a touch of cultural heritage with our Kilim and Sumak rugs.',
    fr: "Découvrez la riche tradition des tapis tissés à plat avec nos collections Kilim et Sumak. Fabriqués à la main par des artisans qualifiés, ces tapis présentent des couleurs vives, des motifs géométriques et une belle construction tissée à plat. Explorez des designs tribaux audacieux, des motifs complexes et une touche de patrimoine culturel avec nos tapis Kilim et Sumak.",
    it: "Sperimentate la ricca tradizione dei tappeti tessuti a mano con le nostre collezioni Kilim e Sumak. Realizzati a mano da abili artigiani, questi tappeti mostrano colori vivaci, motivi geometrici e una bellissima costruzione tessuta a piatto. Esplorate audaci disegni tribali, motivi intricati e un tocco di patrimonio culturale con i nostri tappeti Kilim e Sumak.",
    es: "Experimente la rica tradición de las alfombras de tejido plano con nuestras colecciones Kilim y Sumak. Elaboradas a mano por artesanos expertos, estas alfombras muestran colores vibrantes, patrones geométricos y una hermosa construcción de tejido plano. Explore diseños tribales audaces, motivos intrincados y un toque de herencia cultural con nuestras alfombras Kilim y Sumak."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Add Texture and Tradition to Your Space</h2>
          <p>At YourCarpet.com, we celebrate the rich heritage and artistry of <strong>Kilim and Sumak rugs</strong>. Our collection features a stunning array of <strong>kilim wool rugs</strong>, <strong>sumak rugs</strong>, and <strong>kilim area rugs</strong> that bring texture, color, and cultural charm to any space. Whether you{"'"}re looking for an <strong>Iranian kilim rug</strong> with intricate patterns or a <strong>kilim style rug</strong> to complement your decor, our collection has something for every taste.</p>
          <p>Our <strong>Kilim and Sumak rugs</strong> are more than just floor coverings—they{"'"}re pieces of art that tell a story. With their vibrant colors, geometric patterns, and durable craftsmanship, these rugs are perfect for adding a touch of tradition and elegance to your home.</p>
        </section>

        <section>
          <h2>Why Choose Kilim and Sumak Rugs?</h2>
          <p>Kilim and Sumak rugs are the perfect choice for those who appreciate handmade craftsmanship and cultural heritage. Here{"'"}s why our <strong>Kilim and Sumak rugs</strong> stand out:</p>
          <ul>
            <li><strong>Handmade Craftsmanship</strong>: Each <strong>kilim rug</strong> and <strong>sumak rug</strong> is meticulously handwoven, showcasing the skill and artistry of traditional weavers.</li>
            <li><strong>Durability</strong>: Made from high-quality wool and natural fibers, our <strong>kilim wool rugs</strong> and <strong>sumak rugs</strong> are built to last, ensuring they remain a centerpiece in your home for years to come.</li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a living room, bedroom, or dining room, our <strong>kilim area rugs</strong> and <strong>sumak rugs</strong> complement a wide range of interior styles.</li>
            <li><strong>Cultural Charm</strong>: Our <strong>Iranian kilim rugs</strong> and <strong>kilim style rugs</strong> bring a touch of cultural heritage and timeless beauty to your space.</li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Kilim and Sumak Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some highlights:</p>
          <ul>
            <li><strong>Kilim Wool Rugs</strong>: Add warmth and texture to your home with our <strong>kilim wool rugs</strong>, featuring vibrant colors and geometric patterns.</li>
            <li><strong>Sumak Rugs</strong>: Known for their intricate designs and rich textures, our <strong>sumak rugs</strong> are perfect for adding a touch of elegance to any room.</li>
            <li><strong>Iranian Kilim Rugs</strong>: Celebrate the artistry of Persian weaving with our <strong>Iranian kilim rugs</strong>, featuring intricate patterns and rich cultural heritage.</li>
            <li><strong>Kilim Area Rugs</strong>: Perfect for larger spaces, our <strong>kilim area rugs</strong> make a bold statement with their vibrant designs and durable craftsmanship.</li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Kilim or Sumak Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>kilim rug</strong> to add texture to your living room or a <strong>sumak rug</strong> to anchor your dining room, YourCarpet.com has you covered. Our collection includes a variety of sizes, from small accent rugs to large statement pieces, ensuring you{"'"}ll find the perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>Kilim or Sumak rug</strong> to transform your space. With their timeless beauty and exceptional quality, our <strong>Kilim and Sumak rugs</strong> are sure to become a cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for Unique Patterns?</h2>
          <p>If you{"'"}re drawn to unique and artistic designs, check out our <a href="https://www.yourcarpet.com/en/shop/carpets?styles=patchwork">Patchwork Rugs Collection</a>. Featuring a blend of patterns, colors, and textures, our <strong>patchwork rugs</strong> are perfect for adding character and charm to any space.</p>
        </section>
      </>
    ),
    es: (
      <>
        <section>
          <h2>Añade Textura y Tradición a Tu Espacio</h2>
          <p>En YourCarpet.com, celebramos el rico patrimonio y la artesanía de las <strong>alfombras Kilim y Sumak</strong>. Nuestra colección presenta una impresionante variedad de <strong>alfombras kilim de lana</strong>, <strong>alfombras sumak</strong> y <strong>alfombras de área kilim</strong> que aportan textura, color y encanto cultural a cualquier espacio. Ya sea que busques una <strong>alfombra kilim iraní</strong> con patrones intrincados o una <strong>alfombra estilo kilim</strong> para complementar tu decoración, nuestra colección tiene algo para todos los gustos.</p>
          <p>Nuestras <strong>alfombras Kilim y Sumak</strong> son más que simples coberturas para el suelo—son piezas de arte que cuentan una historia. Con sus colores vibrantes, patrones geométricos y artesanía duradera, estas alfombras son perfectas para añadir un toque de tradición y elegancia a tu hogar.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Kilim y Sumak?</h2>
          <p>Las alfombras Kilim y Sumak son la elección perfecta para quienes aprecian la artesanía hecha a mano y el patrimonio cultural. Estas son las razones por las que nuestras <strong>alfombras Kilim y Sumak</strong> se destacan:</p>
          <ul>
            <li><strong>Artesanía Hecha a Mano</strong>: Cada <strong>alfombra kilim</strong> y <strong>alfombra sumak</strong> está meticulosamente tejida a mano, mostrando la habilidad y el arte de los tejedores tradicionales.</li>
            <li><strong>Durabilidad</strong>: Fabricadas con lana de alta calidad y fibras naturales, nuestras <strong>alfombras kilim de lana</strong> y <strong>alfombras sumak</strong> están construidas para durar, asegurando que permanezcan como pieza central en tu hogar durante años.</li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una sala de estar, un dormitorio o un comedor, nuestras <strong>alfombras de área kilim</strong> y <strong>alfombras sumak</strong> complementan una amplia gama de estilos de interior.</li>
            <li><strong>Encanto Cultural</strong>: Nuestras <strong>alfombras kilim iraníes</strong> y <strong>alfombras estilo kilim</strong> aportan un toque de patrimonio cultural y belleza atemporal a tu espacio.</li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Kilim y Sumak</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos destacados:</p>
          <ul>
            <li><strong>Alfombras Kilim de Lana</strong>: Añade calidez y textura a tu hogar con nuestras <strong>alfombras kilim de lana</strong>, con colores vibrantes y patrones geométricos.</li>
            <li><strong>Alfombras Sumak</strong>: Conocidas por sus diseños intrincados y ricas texturas, nuestras <strong>alfombras sumak</strong> son perfectas para añadir un toque de elegancia a cualquier habitación.</li>
            <li><strong>Alfombras Kilim Iraníes</strong>: Celebra la artesanía del tejido persa con nuestras <strong>alfombras kilim iraníes</strong>, con patrones intrincados y rico patrimonio cultural.</li>
            <li><strong>Alfombras de Área Kilim</strong>: Perfectas para espacios más grandes, nuestras <strong>alfombras de área kilim</strong> hacen una declaración audaz con sus diseños vibrantes y artesanía duradera.</li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Kilim o Sumak Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra kilim</strong> para añadir textura a tu sala de estar o una <strong>alfombra sumak</strong> para anclar tu comedor, YourCarpet.com te tiene cubierto. Nuestra colección incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de declaración, asegurando que encontrarás el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra Kilim o Sumak</strong> perfecta para transformar tu espacio. Con su belleza atemporal y calidad excepcional, nuestras <strong>alfombras Kilim y Sumak</strong> seguramente se convertirán en una parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas Patrones Únicos?</h2>
          <p>Si te atraen los diseños únicos y artísticos, echa un vistazo a nuestra <a href="https://www.yourcarpet.com/es/shop/carpets?styles=patchwork">Colección de Alfombras Patchwork</a>. Con una mezcla de patrones, colores y texturas, nuestras <strong>alfombras patchwork</strong> son perfectas para añadir carácter y encanto a cualquier espacio.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Kilim and Sumak Rugs Collection',
      es: 'Colección de Alfombras Kilim y Sumak'
    },
    subtitle: {
      en: 'Timeless Texture and Cultural Charm',
      es: 'Textura Atemporal y Encanto Cultural',
    },
    description: {
      en: 'Discover our exquisite collection of Kilim and Sumak rugs at YourCarpet.com. From kilim wool rugs to sumak rugs, find the perfect piece for your living room, bedroom, or any space. Shop now!',
      es: 'Descubra nuestra exquisita colección de alfombras Kilim y Sumak en YourCarpet.com. Desde alfombras de lana kilim hasta alfombras sumak, encuentre la pieza perfecta para su sala de estar, dormitorio o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['kilims rug', 'kilim carpets for sale', 'kilim wool rugs', 'killim rugs', 'rugs and kilims', 'kilim style rug', 'iranian kilim rugs', 'kilim rugs for sale', 'kilim wool rug', 'kilim area rug', 'kelim rugs', 'soumak rugs', 'sumak rug'],
      es: ['alfombra kilims', 'alfombras kilim en venta', 'alfombras de lana kilim', 'alfombras killim', 'alfombras y kilims', 'alfombra estilo kilim', 'alfombras kilim iraníes', 'alfombras kilim en venta', 'alfombra de lana kilim', 'alfombra de área kilim', 'alfombras kelim', 'alfombras soumak', 'alfombra sumak']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our stunning collection of Kilim and Sumak rugs. Perfect for adding texture and cultural charm to your home. Shop kilim wool rugs, sumak rugs, and more.',
      es: 'Explore nuestra impresionante colección de alfombras Kilim y Sumak. Perfectas para añadir textura y encanto cultural a su hogar. Compre alfombras de lana kilim, alfombras sumak y más.'
    },
    twitter: {
      en: 'Discover our exquisite Kilim and Sumak rugs collection. Perfect for living rooms, bedrooms, and more. Shop now!',
      es: 'Descubra nuestra exquisita colección de alfombras Kilim y Sumak. Perfectas para salas de estar, dormitorios y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of Kilim and Sumak rugs, including kilim wool rugs, sumak rugs, and more. Perfect for adding texture and cultural charm to any space.',
      es: 'Explore nuestra amplia gama de alfombras Kilim y Sumak, incluyendo alfombras de lana kilim, alfombras sumak y más. Perfectas para añadir textura y encanto cultural a cualquier espacio.'
    }
  }
});

// Plain
stylesCodes.addData(5, {
  name: {en: 'plain', fr: 'uni', it: 'semplice', es: 'liso'},
  summary: {
    en: 'Indulge in minimalist elegance with our plain rugs. Available in a variety of luxurious fabrics like wool, silk, and viscose, these rugs add a touch of sophistication to any space. Choose from a spectrum of neutral and bold colors to create a foundation for your décor or a statement piece.',
    fr: "Offrez-vous une élégance minimaliste avec nos tapis unis. Disponibles dans une variété de tissus luxueux comme la laine, la soie et la viscose, ces tapis ajoutent une touche de sophistication à n'importe quel espace. Choisissez parmi un éventail de couleurs neutres et audacieuses pour créer une base pour votre décor ou une pièce maîtresse.",
    it: "Concedetevi un'eleganza minimalista con i nostri tappeti semplici. Disponibili in una varietà di tessuti lussuosi come lana, seta e viscosa, questi tappeti aggiungono un tocco di sofisticatezza a qualsiasi spazio. Scegliete tra uno spettro di colori neutri e audaci per creare una base per il vostro arredamento o un pezzo d'effetto.",
    es: "Disfrute de la elegancia minimalista con nuestras alfombras lisas. Disponibles en una variedad de tejidos lujosos como lana, seda y viscosa, estas alfombras añaden un toque de sofisticación a cualquier espacio. Elija entre un espectro de colores neutros y audaces para crear una base para su decoración o una pieza de declaración."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Elevate Your Space with Plain Rugs</h2>
          <p>At YourCarpet.com, we believe that simplicity is the ultimate sophistication. Our <strong>plain
            rugs</strong> collection is designed to bring elegance and versatility to your home. Whether you{"'"}re looking
            for a <strong>plain beige rug</strong> to create a neutral backdrop or a <strong>plain gray rug</strong> to
            add a modern touch, our collection has something for every style and space.</p>
          <p>Our <strong>plain area rugs</strong> are more than just floor coverings—they{"'"}re the foundation of your
            decor. With their clean lines, soft textures, and timeless appeal, these rugs are perfect for creating a
            calm and cohesive atmosphere in any room.</p>
        </section>

        <section>
          <h2>Why Choose Plain Rugs?</h2>
          <p>Plain rugs are the perfect choice for those who appreciate minimalist design and versatility. Here{"'"}s why
            our <strong>plain rugs</strong> stand out:</p>
          <ul>
            <li><strong>Timeless Appeal</strong>: Our <strong>plain rugs</strong> feature simple, understated designs
              that never go out of style, making them a long-lasting addition to your home.
            </li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a living room, bedroom, or outdoor space,
              our <strong>plain area rugs</strong> complement a wide range of interior styles.
            </li>
            <li><strong>Durability</strong>: Made from high-quality materials, our <strong>plain carpet
              rugs</strong> are built to withstand daily wear and tear, ensuring they remain a centerpiece in your home
              for years to come.
            </li>
            <li><strong>Comfort</strong>: Our <strong>plain rugs</strong> are not only stylish but also soft and
              comfortable underfoot, making them perfect for high-traffic areas.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Plain Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some
            highlights:</p>
          <ul>
            <li><strong>Plain Beige Rugs</strong>: Create a warm and inviting atmosphere with our <strong>plain beige
              rugs</strong>, perfect for neutral decor.
            </li>
            <li><strong>Plain Gray Rugs</strong>: Add a modern touch to your space with our <strong>plain gray
              rugs</strong>, featuring sleek and sophisticated designs.
            </li>
            <li><strong>Plain Cream Rugs</strong>: Brighten up your room with our <strong>plain cream rugs</strong>,
              offering a soft and elegant look.
            </li>
            <li><strong>Plain Outdoor Rugs</strong>: Enhance your outdoor space with our durable and stylish <strong>plain
              outdoor rugs</strong>, designed to withstand the elements.
            </li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Plain Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>plain rug</strong> to add a touch of elegance to your living room or
            a <strong>plain area rug</strong> to anchor your bedroom, YourCarpet.com has you covered. Our collection
            includes a variety of sizes, from small accent rugs to large statement pieces, ensuring you{"'"}ll find the
            perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>plain rug</strong> to transform your space.
            With their timeless simplicity and exceptional quality, our <strong>plain rugs</strong> are sure to become a
            cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for Textured Patterns?</h2>
          <p>If you{"'"}re drawn to textured and patterned designs, check out our <a
            href="https://www.yourcarpet.com/en/shop/carpets?styles=kilim%2Fsumak">Kilim and Sumak Rugs Collection</a>.
            Featuring intricate patterns and cultural charm, our <strong>Kilim and Sumak rugs</strong> are perfect for
            adding a touch of tradition to your space.</p>
        </section>
      </>
    ),
    es: (
      <>
        <section>
          <h2>Eleva Tu Espacio con Alfombras Lisas</h2>
          <p>En YourCarpet.com, creemos que la simplicidad es la máxima sofisticación. Nuestra colección de <strong>alfombras
            lisas</strong> está diseñada para aportar elegancia y versatilidad a tu hogar. Ya sea que busques una <strong>alfombra lisa beige</strong> para crear un fondo neutral o una <strong>alfombra lisa gris</strong> para
            añadir un toque moderno, nuestra colección tiene algo para cada estilo y espacio.</p>
          <p>Nuestras <strong>alfombras de área lisas</strong> son más que simples coberturas para el suelo—son la base de tu
            decoración. Con sus líneas limpias, texturas suaves y atractivo atemporal, estas alfombras son perfectas para crear una
            atmósfera tranquila y cohesiva en cualquier habitación.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Lisas?</h2>
          <p>Las alfombras lisas son la elección perfecta para quienes aprecian el diseño minimalista y la versatilidad. Estas son las
            razones por las que nuestras <strong>alfombras lisas</strong> se destacan:</p>
          <ul>
            <li><strong>Atractivo Atemporal</strong>: Nuestras <strong>alfombras lisas</strong> presentan diseños simples y discretos
              que nunca pasan de moda, convirtiéndolas en una adición duradera para tu hogar.
            </li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una sala de estar, un dormitorio o un espacio exterior,
              nuestras <strong>alfombras de área lisas</strong> complementan una amplia gama de estilos de interior.
            </li>
            <li><strong>Durabilidad</strong>: Fabricadas con materiales de alta calidad, nuestras <strong>alfombras y moquetas
              lisas</strong> están construidas para resistir el desgaste diario, asegurando que permanezcan como pieza central en tu hogar
              durante años.
            </li>
            <li><strong>Comodidad</strong>: Nuestras <strong>alfombras lisas</strong> no solo son elegantes sino también suaves y
              cómodas al pisar, haciéndolas perfectas para áreas de alto tráfico.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Lisas</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos
            destacados:</p>
          <ul>
            <li><strong>Alfombras Lisas Beige</strong>: Crea una atmósfera cálida y acogedora con nuestras <strong>alfombras lisas
              beige</strong>, perfectas para decoración neutral.
            </li>
            <li><strong>Alfombras Lisas Grises</strong>: Añade un toque moderno a tu espacio con nuestras <strong>alfombras lisas
              grises</strong>, con diseños elegantes y sofisticados.
            </li>
            <li><strong>Alfombras Lisas Crema</strong>: Ilumina tu habitación con nuestras <strong>alfombras lisas crema</strong>,
              ofreciendo un aspecto suave y elegante.
            </li>
            <li><strong>Alfombras Lisas para Exterior</strong>: Mejora tu espacio exterior con nuestras duraderas y elegantes <strong>alfombras
              lisas para exterior</strong>, diseñadas para resistir los elementos.
            </li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Lisa Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra lisa</strong> para añadir un toque de elegancia a tu sala de estar o
            una <strong>alfombra de área lisa</strong> para anclar tu dormitorio, YourCarpet.com te tiene cubierto. Nuestra colección
            incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de declaración, asegurando que encontrarás
            el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra lisa</strong> perfecta para transformar tu espacio.
            Con su simplicidad atemporal y calidad excepcional, nuestras <strong>alfombras lisas</strong> seguramente se convertirán en una
            parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas Patrones con Textura?</h2>
          <p>Si te atraen los diseños con textura y patrones, echa un vistazo a nuestra <a
            href="https://www.yourcarpet.com/es/shop/carpets?styles=kilim%2Fsumak">Colección de Alfombras Kilim y Sumak</a>.
            Con patrones intrincados y encanto cultural, nuestras <strong>alfombras Kilim y Sumak</strong> son perfectas para
            añadir un toque de tradición a tu espacio.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Plain Rugs Collection',
      es: 'Colección de Alfombras Lisas'
    },
    subtitle: {
      en: 'Simplicity, Elegance, and Timeless Style',
      es: 'Simplicidad, Elegancia y Estilo Atemporal',
    },
    description: {
      en: 'Discover our elegant collection of plain rugs at YourCarpet.com. From plain beige rugs to plain gray rugs, find the perfect minimalist piece for your living room, bedroom, or outdoor space. Shop now!"',
      es: 'Descubra nuestra elegante colección de alfombras lisas en YourCarpet.com. Desde alfombras beige lisas hasta alfombras grises lisas, encuentre la pieza minimalista perfecta para su sala de estar, dormitorio o espacio exterior. ¡Compre ahora!',
    },
    keywords: {
      en: ['plain rugs', 'plain carpet rugs', 'plain area rugs', 'plain rug', 'plain beige rug', 'plain cream rug', 'plain grey rug', 'plain outdoor rug', 'plain gray rug'],
      es: ['alfombras lisas', 'alfombras de moqueta lisas', 'alfombras de área lisas', 'alfombra lisa', 'alfombra beige lisa', 'alfombra crema lisa', 'alfombra gris lisa', 'alfombra exterior lisa', 'alfombra gris lisa']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our minimalist collection of plain rugs. Perfect for adding simplicity and elegance to your home. Shop plain beige rugs, plain gray rugs, and more.',
      es: 'Explore nuestra colección minimalista de alfombras lisas. Perfectas para añadir simplicidad y elegancia a su hogar. Compre alfombras beige lisas, alfombras grises lisas y más.'
    },
    twitter: {
      en: 'Discover our elegant plain rugs collection. Perfect for living rooms, bedrooms, and outdoor spaces. Shop now!',
      es: 'Descubra nuestra elegante colección de alfombras lisas. Perfectas para salas de estar, dormitorios y espacios exteriores. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of plain rugs, including plain beige rugs, plain gray rugs, and more. Perfect for adding simplicity and elegance to any space.',
      es: 'Explore nuestra amplia gama de alfombras lisas, incluyendo alfombras beige lisas, alfombras grises lisas y más. Perfectas para añadir simplicidad y elegancia a cualquier espacio.'
    }
  }
});

// Geometric
stylesCodes.addData(6, {
  name: {en: 'geometric', fr: 'géométrique', it: 'geometrico', es: 'geométrico'},
  summary: {
    en: 'Make a bold statement with our eye-catching geometric rugs. Featuring a variety of shapes, patterns, and scales, these rugs add a touch of modern flair and visual interest to your space. Explore contemporary chevron patterns, classic Moroccan trellis designs, or playful triangles, all crafted with the highest quality.',
    fr: "Faites une déclaration audacieuse avec nos tapis géométriques accrocheurs. Présentant une variété de formes, de motifs et d'échelles, ces tapis ajoutent une touche de modernité et d'intérêt visuel à votre espace. Explorez les motifs chevron contemporains, les designs en treillis marocains classiques ou les triangles ludiques, tous fabriqués avec la plus haute qualité.",
    it: "Fate una dichiarazione audace con i nostri tappeti geometrici accattivanti. Con una varietà di forme, motivi e scale, questi tappeti aggiungono un tocco di stile moderno e interesse visivo al vostro spazio. Esplorate moderni motivi a chevron, classici disegni a traliccio marocchini o triangoli giocosi, tutti realizzati con la massima qualità.",
    es: "Haga una declaración audaz con nuestras llamativas alfombras geométricas. Con una variedad de formas, patrones y escalas, estas alfombras añaden un toque de estilo moderno e interés visual a su espacio. Explore patrones de chevron contemporáneos, diseños de celosía marroquí clásicos o triángulos juguetones, todos elaborados con la más alta calidad."
  },
  text: {
    en: (
      <>
        <section>
          <h2>Add a Modern Touch with Geometric Rugs</h2>
          <p>At YourCarpet.com, we bring you a stunning collection of <strong>geometric rugs</strong> that combine
            modern design with artistic flair. Whether you{"'"}re looking for a <strong>modern geometric rug</strong> to
            anchor your living room or a <strong>natural geometric rug</strong> to add texture to your space, our
            collection has something for every taste. Explore our <strong>rugs geometric</strong> and discover the
            perfect piece to elevate your home decor.</p>
          <p>Our <strong>geometric rugs</strong> are more than just floor coverings—they{"'"}re works of art that bring
            personality and style to any room. With their bold patterns, clean lines, and versatile designs, these rugs
            are perfect for creating a focal point in your home.</p>
        </section>

        <section>
          <h2>Why Choose Geometric Rugs?</h2>
          <p>Geometric rugs are the perfect choice for those who love modern design and artistic patterns. Here{"'"}s why
            our <strong>geometric rugs</strong> stand out:</p>
          <ul>
            <li><strong>Modern Design</strong>: Our <strong>modern geometric rugs</strong> feature sleek patterns and
              contemporary designs that add a fresh touch to any space.
            </li>
            <li><strong>Versatility</strong>: Whether you{"'"}re decorating a living room, bedroom, or office, our <strong>rug
              geometric pattern</strong> options complement a wide range of interior styles.
            </li>
            <li><strong>Durability</strong>: Made from high-quality materials, our <strong>geometric rugs</strong> are
              built to last, ensuring they remain a centerpiece in your home for years to come.
            </li>
            <li><strong>Comfort</strong>: Our <strong>geometric washable rugs</strong> are not only stylish but also
              soft and easy to maintain, making them perfect for high-traffic areas.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Geometric Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some
            highlights:</p>
          <ul>
            <li><strong>Modern Geometric Rugs</strong>: Add a contemporary touch to your space with our <strong>modern
              geometric rugs</strong>, featuring bold patterns and vibrant colors.
            </li>
            <li><strong>Natural Geometric Rugs</strong>: Bring the beauty of nature indoors with our <strong>natural
              geometric rugs</strong>, featuring earthy tones and organic textures.
            </li>
            <li><strong>Geometric Beige Rugs</strong>: Create a neutral yet stylish backdrop with our <strong>geometric
              beige rugs</strong>, perfect for minimalist decor.
            </li>
            <li><strong>Geometric Rugs for Living Room</strong>: Make a statement in your living room with our <strong>geometric
              rugs for living room</strong>, designed to anchor your furniture and tie your decor together.
            </li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Geometric Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>geometric rug</strong> to add a pop of pattern to your living room
            or a <strong>beige geometric rug</strong> to complement your neutral decor, YourCarpet.com has you covered.
            Our collection includes a variety of sizes, from small accent rugs to large statement pieces, ensuring
            you{"'"}ll find the perfect fit for your home.</p>
          <p>Explore our collection today and discover the perfect <strong>geometric rug</strong> to transform your
            space. With their modern designs and exceptional quality, our <strong>geometric rugs</strong> are sure to
            become a cherished part of your decor.</p>
        </section>

        <section>
          <h2>Looking for Minimalist Designs?</h2>
          <p>If you prefer simplicity and elegance, check out our <a
            href="https://www.yourcarpet.com/en/shop/carpets?styles=plain">Plain Rugs Collection</a>. Featuring clean
            lines and timeless designs, our <strong>plain rugs</strong> are perfect for creating a calm and cohesive
            atmosphere in any room.</p>
        </section>

      </>
    ),
    es: (
      <>
        <section>
          <h2>Añade un Toque Moderno con Alfombras Geométricas</h2>
          <p>En YourCarpet.com, te ofrecemos una impresionante colección de <strong>alfombras geométricas</strong> que combinan
            diseño moderno con estilo artístico. Ya sea que busques una <strong>alfombra geométrica moderna</strong> para
            anclar tu sala de estar o una <strong>alfombra geométrica natural</strong> para añadir textura a tu espacio, nuestra
            colección tiene algo para todos los gustos. Explora nuestras <strong>alfombras con diseños geométricos</strong> y descubre la
            pieza perfecta para elevar la decoración de tu hogar.</p>
          <p>Nuestras <strong>alfombras geométricas</strong> son más que simples coberturas para el suelo—son obras de arte que aportan
            personalidad y estilo a cualquier habitación. Con sus patrones audaces, líneas limpias y diseños versátiles, estas alfombras
            son perfectas para crear un punto focal en tu hogar.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Geométricas?</h2>
          <p>Las alfombras geométricas son la elección perfecta para quienes aman el diseño moderno y los patrones artísticos. Estas son las
            razones por las que nuestras <strong>alfombras geométricas</strong> se destacan:</p>
          <ul>
            <li><strong>Diseño Moderno</strong>: Nuestras <strong>alfombras geométricas modernas</strong> presentan patrones elegantes y
              diseños contemporáneos que añaden un toque fresco a cualquier espacio.
            </li>
            <li><strong>Versatilidad</strong>: Ya sea que estés decorando una sala de estar, un dormitorio o una oficina, nuestras opciones de <strong>
              alfombras con patrones geométricos</strong> complementan una amplia gama de estilos de interior.
            </li>
            <li><strong>Durabilidad</strong>: Fabricadas con materiales de alta calidad, nuestras <strong>alfombras geométricas</strong> están
              construidas para durar, asegurando que permanezcan como pieza central en tu hogar durante años.
            </li>
            <li><strong>Comodidad</strong>: Nuestras <strong>alfombras geométricas lavables</strong> no solo son elegantes sino también
              suaves y fáciles de mantener, haciéndolas perfectas para áreas de alto tráfico.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Geométricas</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos
            destacados:</p>
          <ul>
            <li><strong>Alfombras Geométricas Modernas</strong>: Añade un toque contemporáneo a tu espacio con nuestras <strong>alfombras
              geométricas modernas</strong>, con patrones audaces y colores vibrantes.
            </li>
            <li><strong>Alfombras Geométricas Naturales</strong>: Trae la belleza de la naturaleza al interior con nuestras <strong>alfombras
              geométricas naturales</strong>, con tonos terrosos y texturas orgánicas.
            </li>
            <li><strong>Alfombras Geométricas Beige</strong>: Crea un fondo neutral pero elegante con nuestras <strong>alfombras
              geométricas beige</strong>, perfectas para decoración minimalista.
            </li>
            <li><strong>Alfombras Geométricas para Sala de Estar</strong>: Haz una declaración en tu sala de estar con nuestras <strong>alfombras
              geométricas para sala de estar</strong>, diseñadas para anclar tus muebles y unificar tu decoración.
            </li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Geométrica Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra geométrica</strong> para añadir un toque de patrón a tu sala de estar
            o una <strong>alfombra geométrica beige</strong> para complementar tu decoración neutral, YourCarpet.com te tiene cubierto.
            Nuestra colección incluye una variedad de tamaños, desde pequeñas alfombras de acento hasta grandes piezas de declaración, asegurando
            que encontrarás el ajuste perfecto para tu hogar.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra geométrica</strong> perfecta para transformar tu
            espacio. Con sus diseños modernos y calidad excepcional, nuestras <strong>alfombras geométricas</strong> seguramente se
            convertirán en una parte apreciada de tu decoración.</p>
        </section>

        <section>
          <h2>¿Buscas Diseños Minimalistas?</h2>
          <p>Si prefieres la simplicidad y la elegancia, echa un vistazo a nuestra <a
            href="https://www.yourcarpet.com/es/shop/carpets?styles=plain">Colección de Alfombras Lisas</a>. Con líneas
            limpias y diseños atemporales, nuestras <strong>alfombras lisas</strong> son perfectas para crear una atmósfera
            tranquila y cohesiva en cualquier habitación.</p>
        </section>
      </>
    ),
  },
  htmlHead: {
    title: {
      en: 'Geometric Rugs Collection',
      es: 'Colección de Alfombras Geométricas'
    },
    subtitle: {
      en: 'Modern, Artistic, and Full of Character',
      es: 'Modernas, Artísticas y Llenas de Carácter',
    },
    description: {
      en: 'Discover our stylish collection of geometric rugs at YourCarpet.com. From modern geometric rugs to natural geometric rugs, find the perfect piece for your living room, bedroom, or any space. Shop now!',
      es: 'Descubra nuestra elegante colección de alfombras geométricas en YourCarpet.com. Desde alfombras geométricas modernas hasta alfombras geométricas naturales, encuentre la pieza perfecta para su sala de estar, dormitorio o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['geometric rugs', 'natural geometric rug', 'geonetric rug', 'rug geometric pattern', 'rugs geometric', 'rug geometric', 'geometric beige rug', 'geometric washable rug', 'geometric pattern rug', 'beige geometric rug', 'geometric rugs for living room', 'modern geometric rug', 'geometric rug', 'modern geometric area rugs'],
      es: ['alfombras geométricas', 'alfombra geométrica natural', 'alfombra geonetrica', 'alfombra con patrón geométrico', 'alfombras geométricas', 'alfombra geométrica', 'alfombra beige geométrica', 'alfombra geométrica lavable', 'alfombra con patrón geométrico', 'alfombra geométrica beige', 'alfombras geométricas para sala de estar', 'alfombra geométrica moderna', 'alfombra geométrica', 'alfombras de área geométricas modernas']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Explore our stylish collection of geometric rugs. Perfect for adding a modern and artistic touch to your home. Shop modern geometric rugs, natural geometric rugs, and more.',
      es: 'Explore nuestra elegante colección de alfombras geométricas. Perfectas para añadir un toque moderno y artístico a su hogar. Compre alfombras geométricas modernas, alfombras geométricas naturales y más.'
    },
    twitter: {
      en: 'Discover our stylish geometric rugs collection. Perfect for living rooms, bedrooms, and more. Shop now!',
      es: 'Descubra nuestra elegante colección de alfombras geométricas. Perfectas para salas de estar, dormitorios y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of geometric rugs, including modern geometric rugs, natural geometric rugs, and more. Perfect for adding a modern and artistic touch to any space.',
      es: 'Explore nuestra amplia gama de alfombras geométricas, incluyendo alfombras geométricas modernas, alfombras geométricas naturales y más. Perfectas para añadir un toque moderno y artístico a cualquier espacio.'
    }
  }
});

// Floral
stylesCodes.addData(7, {
  name: {en: 'floral', fr: 'floral', it: 'floreale', es: 'floral'},
  summary: {
    en: 'Bring the beauty of nature indoors with our captivating floral rugs. From delicate watercolor designs to bold blooming patterns, these rugs add a touch of femininity, romance, and timeless elegance to any space. Explore rugs with traditional floral motifs, contemporary reinterpretations, or vibrant color palettes to create a welcoming and inviting atmosphere.',
    fr: "Apportez la beauté de la nature à l'intérieur avec nos tapis floraux captivants. Des délicats motifs aquarelle aux motifs floraux audacieux, ces tapis ajoutent une touche de féminité, de romance et d'élégance intemporelle à n'importe quel espace. Explorez des tapis aux motifs floraux traditionnels, des réinterprétations contemporaines ou des palettes de couleurs vives pour créer une atmosphère accueillante et invitante.",
    it: "Portate la bellezza della natura in casa con i nostri affascinanti tappeti floreali. Dai delicati disegni ad acquerello ai motivi floreali audaci, questi tappeti aggiungono un tocco di femminilità, romanticismo ed eleganza senza tempo a qualsiasi spazio. Esplorate tappeti con motivi floreali tradizionali, reinterpretazioni contemporanee o vivaci palette di colori per creare un'atmosfera accogliente e invitante.",
    es: "Traiga la belleza de la naturaleza al interior con nuestras cautivadoras alfombras florales. Desde delicados diseños de acuarela hasta audaces patrones florales, estas alfombras añaden un toque de feminidad, romance y elegancia atemporal a cualquier espacio. Explore alfombras con motivos florales tradicionales, reinterpretaciones contemporáneas o vibrantes paletas de colores para crear una atmósfera acogedora e invitadora."
  },
  text: {
    en:
      (<>
        <section>
          <h2>Transform Your Space with Floral Rugs</h2>
          <p>At YourCarpet.com, we believe that every home deserves a touch of nature{"'"}s beauty. Our <strong>floral
            rugs</strong> collection is designed to bring the elegance and charm of blooming flowers into your living
            spaces. Whether you{"'"}re looking for a <strong>modern floral carpet</strong> to complement a contemporary
            interior or a <strong>traditional flower area rug</strong> to add warmth to a classic setting, we have the
            perfect piece for you.</p>
          <p>Our <strong>floral area rugs</strong> are more than just floor coverings—they{"'"}re works of art that elevate
            your home{"'"}s aesthetic. From <strong>colorful floral rugs</strong> that make a bold statement to <strong>neutral
              floral rugs</strong> that blend seamlessly with your decor, our collection offers something for every
            style and preference.</p>
        </section>

        <section>
          <h2>Why Choose Floral Rugs?</h2>
          <p>Floral rugs are a timeless choice for any home. They add a sense of freshness and vitality to your space,
            making them perfect for <strong>living rooms</strong>, <strong>bedrooms</strong>, and even dining areas.
            Here{"'"}s why our <strong>rugs with flowers</strong> stand out:</p>
          <ul>
            <li><strong>Versatility</strong>: Whether you prefer a <strong>large floral rug</strong> for a spacious room
              or a <strong>floral 5x7 rug</strong> for a cozy corner, our collection has options for every space.
            </li>
            <li><strong>Durability</strong>: Crafted from high-quality materials, our <strong>floral pattern
              rugs</strong> are built to last, ensuring they remain a centerpiece in your home for years to come.
            </li>
            <li><strong>Design Variety</strong>: From <strong>modern floral rugs</strong> with sleek patterns
              to <strong>flowered rugs</strong> with intricate details, our designs cater to diverse tastes.
            </li>
            <li><strong>Comfort</strong>: Our <strong>area rugs floral</strong> are not only beautiful but also soft and
              comfortable underfoot, making them perfect for high-traffic areas.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explore Our Floral Rug Collection</h2>
          <p>Our collection features a wide range of styles, sizes, and colors to suit your needs. Here are some highlights:</p>
          <ul>
            <li><strong>Floral Rugs for Living Room</strong>: Add a touch of elegance to your living space with our <strong>floral living room rugs</strong>. These rugs are designed to anchor your furniture and create a cohesive look.</li>
            <li><strong>Floral Bedroom Rugs</strong>: Create a serene and inviting atmosphere in your bedroom with our <strong>floral rugs for bedroom</strong>. Choose from soft pastels or bold patterns to match your decor.</li>
            <li><strong>Contemporary Floral Rugs</strong>: For those who love modern design, our <strong>contemporary floral area rugs</strong> offer sleek patterns and vibrant colors that make a statement.</li>
            <li><strong>Neutral Floral Rugs</strong>: If you prefer a subtle touch, our <strong>neutral floral rugs</strong> feature soft tones and delicate patterns that blend effortlessly with any decor.</li>
            <li><strong>Colorful Floral Rugs</strong>: Brighten up your space with our <strong>colorful floral rugs</strong>, featuring bold hues and eye-catching designs.</li>
          </ul>
        </section>

        <section>
          <h2>Find the Perfect Floral Rug for Your Home</h2>
          <p>Whether you{"'"}re searching for a <strong>floral print rug</strong> to add personality to your space or a <strong>pastel floral rug</strong> for a calming effect, YourCarpet.com has you covered. Our <strong>floral rugs 5x7</strong> are ideal for smaller spaces, while our <strong>large floral rugs</strong> are perfect for making a bold statement in larger rooms.</p>
          <p>Explore our collection today and discover the perfect <strong>rug floral</strong> to transform your home. With a variety of styles, sizes, and colors, you{"'"}re sure to find the perfect piece to match your unique taste and decor.</p>
        </section>
      </>),
    es:
      (<>
        <section>
          <h2>Transforma Tu Espacio con Alfombras Florales</h2>
          <p>En YourCarpet.com, creemos que cada hogar merece un toque de la belleza de la naturaleza. Nuestra colección de <strong>alfombras
            florales</strong> está diseñada para llevar la elegancia y el encanto de las flores en floración a tus espacios
            de vida. Ya sea que busques una <strong>alfombra floral moderna</strong> para complementar un interior contemporáneo
            o una <strong>alfombra de área con flores tradicional</strong> para añadir calidez a un ambiente clásico, tenemos la
            pieza perfecta para ti.</p>
          <p>Nuestras <strong>alfombras de área florales</strong> son más que simples coberturas para el suelo—son obras de arte que elevan
            la estética de tu hogar. Desde <strong>alfombras florales coloridas</strong> que hacen una declaración audaz hasta <strong>alfombras
              florales neutras</strong> que se integran a la perfección con tu decoración, nuestra colección ofrece algo para cada
            estilo y preferencia.</p>
        </section>

        <section>
          <h2>¿Por Qué Elegir Alfombras Florales?</h2>
          <p>Las alfombras florales son una elección atemporal para cualquier hogar. Añaden una sensación de frescura y vitalidad a tu espacio,
            haciéndolas perfectas para <strong>salas de estar</strong>, <strong>dormitorios</strong>, e incluso áreas de comedor.
            Estas son las razones por las que nuestras <strong>alfombras con flores</strong> se destacan:</p>
          <ul>
            <li><strong>Versatilidad</strong>: Ya sea que prefieras una <strong>alfombra floral grande</strong> para una habitación espaciosa
              o una <strong>alfombra floral 5x7</strong> para un rincón acogedor, nuestra colección tiene opciones para cada espacio.
            </li>
            <li><strong>Durabilidad</strong>: Elaboradas con materiales de alta calidad, nuestras <strong>alfombras con patrón
              floral</strong> están construidas para durar, asegurando que permanezcan como pieza central en tu hogar durante años.
            </li>
            <li><strong>Variedad de Diseños</strong>: Desde <strong>alfombras florales modernas</strong> con patrones elegantes
              hasta <strong>alfombras con flores</strong> con detalles intrincados, nuestros diseños atienden a diversos gustos.
            </li>
            <li><strong>Comodidad</strong>: Nuestras <strong>alfombras de área florales</strong> no son solo hermosas sino también suaves y
              cómodas al pisar, haciéndolas perfectas para áreas de alto tráfico.
            </li>
          </ul>
        </section>

        <section>
          <h2>Explora Nuestra Colección de Alfombras Florales</h2>
          <p>Nuestra colección presenta una amplia gama de estilos, tamaños y colores para satisfacer tus necesidades. Aquí algunos destacados:</p>
          <ul>
            <li><strong>Alfombras Florales para Sala de Estar</strong>: Añade un toque de elegancia a tu espacio de vida con nuestras <strong>alfombras florales para sala de estar</strong>. Estas alfombras están diseñadas para anclar tus muebles y crear un aspecto cohesivo.</li>
            <li><strong>Alfombras Florales para Dormitorio</strong>: Crea una atmósfera serena y acogedora en tu dormitorio con nuestras <strong>alfombras florales para dormitorio</strong>. Elige entre pasteles suaves o patrones audaces para combinar con tu decoración.</li>
            <li><strong>Alfombras Florales Contemporáneas</strong>: Para aquellos que aman el diseño moderno, nuestras <strong>alfombras de área florales contemporáneas</strong> ofrecen patrones elegantes y colores vibrantes que hacen una declaración.</li>
            <li><strong>Alfombras Florales Neutras</strong>: Si prefieres un toque sutil, nuestras <strong>alfombras florales neutras</strong> presentan tonos suaves y patrones delicados que se integran sin esfuerzo con cualquier decoración.</li>
            <li><strong>Alfombras Florales Coloridas</strong>: Ilumina tu espacio con nuestras <strong>alfombras florales coloridas</strong>, con tonos audaces y diseños que atraen la mirada.</li>
          </ul>
        </section>

        <section>
          <h2>Encuentra la Alfombra Floral Perfecta para Tu Hogar</h2>
          <p>Ya sea que estés buscando una <strong>alfombra con estampado floral</strong> para añadir personalidad a tu espacio o una <strong>alfombra floral en tonos pastel</strong> para un efecto relajante, YourCarpet.com te tiene cubierto. Nuestras <strong>alfombras florales 5x7</strong> son ideales para espacios más pequeños, mientras que nuestras <strong>alfombras florales grandes</strong> son perfectas para hacer una declaración audaz en habitaciones más amplias.</p>
          <p>Explora nuestra colección hoy y descubre la <strong>alfombra floral</strong> perfecta para transformar tu hogar. Con una variedad de estilos, tamaños y colores, seguramente encontrarás la pieza perfecta para combinar con tu gusto único y decoración.</p>
        </section>
      </>),
  },
  htmlHead: {
    title: {
      en: 'Floral Rugs Collection',
      es: 'Colección de Alfombras Florales'
    },
    subtitle: {
      en: 'Bring the Beauty of Nature into Your Home',
      es: 'Traiga la Belleza de la Naturaleza a su Hogar',
    },
    description: {
      en: 'Explore our exquisite collection of floral rugs at YourCarpet.com. From modern floral carpets to traditional flower area rugs, find the perfect floral rug for your living room, bedroom, or any space. Shop now!',
      es: 'Explore nuestra exquisita colección de alfombras florales en YourCarpet.com. Desde alfombras florales modernas hasta alfombras de área con flores tradicionales, encuentre la alfombra floral perfecta para su sala de estar, dormitorio o cualquier espacio. ¡Compre ahora!',
    },
    keywords: {
      en: ['floral rugs', 'floral rug', 'floral area rugs', 'flower area rug', 'floral area rug', 'rug flower', 'rugs with flowers', 'rugs floral', 'floral rugs for living room', 'modern floral carpet', 'rug floral', 'flowered rugs', 'area rug floral', 'flower rugs', 'flower area rugs', 'floral rugs 5x7', 'floral contemporary rugs', 'floral living room rugs', 'large floral rug', 'floral print rug', 'area rugs floral', 'neutral floral rug', 'floral pattern rug', 'colorful floral rugs', 'modern floral rug', 'pastel floral rug', 'floral rug living room', 'floral bedroom rugs', 'contemporary floral area rugs', 'flower pattern rug', 'floral rugs for bedroom', 'floral 5x7 rug'],
      es: ['alfombras florales', 'alfombra floral', 'alfombras de área florales', 'alfombra de área con flores', 'alfombra de área floral', 'alfombra de flores', 'alfombras con flores', 'alfombras florales', 'alfombras florales para sala de estar', 'alfombra floral moderna', 'alfombra floral', 'alfombras con flores', 'alfombra de área floral', 'alfombras de flores', 'alfombras de área con flores', 'alfombras florales 5x7', 'alfombras contemporáneas florales', 'alfombras florales para sala de estar', 'alfombra floral grande', 'alfombra estampada floral', 'alfombras de área florales', 'alfombra floral neutral', 'alfombra con patrón floral', 'alfombras florales coloridas', 'alfombra floral moderna', 'alfombra floral pastel', 'alfombra floral sala de estar', 'alfombras florales para dormitorio', 'alfombras de área contemporáneas florales', 'alfombra con patrón de flores', 'alfombras florales para dormitorio', 'alfombra floral 5x7']
    },
    image: 'https://www.yourcarpet.com/assets/open-graph/main-og.png',
    og: {
      en: 'Discover our stunning floral rugs collection. Perfect for adding a touch of nature to your home. Shop modern, colorful, and neutral floral rugs for every room.',
      es: 'Descubra nuestra impresionante colección de alfombras florales. Perfectas para añadir un toque de naturaleza a su hogar. Compre alfombras florales modernas, coloridas y neutrales para cada habitación.'
    },
    twitter: {
      en: 'Explore our beautiful floral rugs collection. Perfect for living rooms, bedrooms, and more. Shop now!',
      es: 'Explore nuestra hermosa colección de alfombras florales. Perfectas para salas de estar, dormitorios y más. ¡Compre ahora!'
    },
    schema: {
      '@type': 'CollectionPage',
      en: 'Explore our wide range of floral rugs, including modern floral carpets, traditional flower area rugs, and more. Perfect for any room in your home.',
      es: 'Explore nuestra amplia gama de alfombras florales, incluyendo alfombras florales modernas, alfombras de área con flores tradicionales y más. Perfectas para cualquier habitación de su hogar.'
    }
  }
});


export default stylesCodes;
